import React from "react";
import { useTranslation } from "react-i18next";
import { motion, AnimatePresence } from "framer-motion";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPiggyBank } from "@fortawesome/free-solid-svg-icons";

function SavingAccountList({ accounts, onDeleteSavingAccount }) {
  const { t } = useTranslation();

  return (
    <div className="card bg-white dark:bg-dark-surface p-6 transition-colors">
      <h2 className="text-xl font-bold text-gray-800 dark:text-white mb-4 flex items-center gap-2">
        <FontAwesomeIcon icon={faPiggyBank} className="text-primary-500" />
        {t("savingAccounts")}
      </h2>

      {accounts.length === 0 ? (
        <div className="text-center py-8 bg-gray-50 dark:bg-dark-bg rounded-xl border border-dashed border-gray-200 dark:border-gray-700">
          <p className="text-gray-500 dark:text-gray-400">{t("noSavingAccountsFound")}</p>
        </div>
      ) : (
        <ul className="space-y-3">
          <AnimatePresence>
            {accounts.map((account) => (
              <motion.li
                key={account.id}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, x: -10 }}
                className="flex items-center justify-between bg-gray-50 dark:bg-dark-bg p-4 rounded-xl border border-gray-100 dark:border-gray-700 group hover:bg-white dark:hover:bg-gray-800 hover:shadow-sm transition-all"
              >
                <div className="flex flex-col">
                  <span className="font-bold text-gray-800 dark:text-white text-lg">{account.name}</span>
                  <div className="flex items-center gap-2 text-sm text-gray-500 dark:text-gray-400">
                    <span className="bg-green-100 dark:bg-green-900/30 text-green-700 dark:text-green-300 px-2 py-0.5 rounded-md text-xs font-medium">
                      {account.currency}
                    </span>
                    <span>•</span>
                    <span>{account.holder}</span>
                  </div>
                </div>

                <div className="flex items-center gap-4">
                  {onDeleteSavingAccount && (
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDeleteSavingAccount(account.id);
                      }}
                      className="p-2 text-gray-400 hover:text-red-600 dark:text-gray-500 dark:hover:text-red-400 rounded-lg hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors relative z-20 pointer-events-auto"
                      title={t("delete")}
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  )}
                </div>
              </motion.li>
            ))}
          </AnimatePresence>
        </ul>
      )}
    </div>
  );
}

export default SavingAccountList;
